import { ColorTokens } from '@mythical/ui'

export type ColorEnum =
  | 'background_primary'
  | 'background_secondary'
  | 'background-primary'
  | 'background-secondary'
  | 'white'
  | 'blue'
  | 'teal'
  | 'olive'
  | 'purple'
  | 'pink'
  | 'mustard'
  | 'rust'

const colorMap: Record<ColorEnum, ColorTokens> = {
  'background_primary': '$bgPrimary',
  'background_secondary': '$bgSecondary',
  'background-primary': '$bgPrimary',
  'background-secondary': '$bgSecondary',
  white: '$fgPrimary',
  teal: '$brandTeal',
  blue: '$brandBlue',
  olive: '$brandOlive',
  purple: '$brandPurple',
  pink: '$brandPink',
  mustard: '$brandMustard',
  rust: '$brandRust',
}

/**
 * Maps GraphQL color enum to theme token
 * @param color - Color enum from GraphQL schema
 * @returns Theme token string (e.g., '$brandPurple')
 */
export const mapColor = (color?: ColorEnum): ColorTokens => {
  if (!color) return '$brandPurple' // Default fallback
  return colorMap[color] || '$brandPurple'
}
